// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.backBtnContainer {
    position: absolute;
    cursor: pointer;
    display: none; /* hidden back button for now */
    align-items: center;
    gap: 10px;
    top: 3%;
    left: 5%;
}

.backBtnText {
    font-family: "Poppins", sans-serif;
    font-weight: 600px;
    line-height: 32px;
    font-size: 18px;
    color: #48d1cc;
}`, "",{"version":3,"sources":["webpack://./src/Pages/SignUpPage/SignUpPage.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,eAAe;IACf,aAAa,EAAE,+BAA+B;IAC9C,mBAAmB;IACnB,SAAS;IACT,OAAO;IACP,QAAQ;AACZ;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB","sourcesContent":[".backBtnContainer {\n    position: absolute;\n    cursor: pointer;\n    display: none; /* hidden back button for now */\n    align-items: center;\n    gap: 10px;\n    top: 3%;\n    left: 5%;\n}\n\n.backBtnText {\n    font-family: \"Poppins\", sans-serif;\n    font-weight: 600px;\n    line-height: 32px;\n    font-size: 18px;\n    color: #48d1cc;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
